import Hero from "../components/Hero";
import TrustedMarquee from "../components/TrustedMarquee";
import Services from "../components/Services";
import FeaturedWork from "../components/FeaturedWork";
import HowIWork from "../components/HowIWork";
import ResultsStrip from "../components/ResultsStrip";
import Testimonials from "../components/Testimonials";
import EditorialMarquee from "../components/EditorialMarquee";
import Faq from "../components/Faq";
import Pricing from "../components/Pricing";
import Contact from "../components/Contact";
import Seo from "../components/Seo";
import { HOME_SCHEMA } from "../data/schema";
import { SEO_HOME } from "../data/portfolio";
import { ScrollScale } from "../components/Motion";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo title={SEO_HOME.title} description={SEO_HOME.description} path="/" schema={HOME_SCHEMA} />
      <Hero />
      <ScrollScale><TrustedMarquee /></ScrollScale>
      <ScrollScale><Services /></ScrollScale>
      <FeaturedWork />
      <ScrollScale><HowIWork /></ScrollScale>
      <ScrollScale><ResultsStrip /></ScrollScale>
      <ScrollScale><Testimonials /></ScrollScale>
      <ScrollScale><EditorialMarquee /></ScrollScale>
      <ScrollScale><Faq /></ScrollScale>
      <ScrollScale><Pricing /></ScrollScale>
      <ScrollScale><Contact /></ScrollScale>
    </main>
  );
}
